import React, { useRef, useEffect } from "react";
import { gsap, Power1 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { motion } from "framer-motion";
import Bio from "./Bio";
import { useInView } from "react-intersection-observer";
import Skills from "./Skills";

gsap.registerPlugin(ScrollTrigger);
const About = ({ setCursorHovered }) => {
  let reff = useRef(null);
  let scrollText = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0,
  });
  useEffect(() => {
    const element = reff.current;
    const title = element.querySelector(".title");
    const name = element.querySelector("h1");
    const para = element.querySelectorAll("p");
    const first_scroll = scrollText.firstChild;
    const second_scroll = scrollText.lastChild;

    gsap.fromTo(
      title,
      0.6,
      { y: 144, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: title,
          start: "top bottom-=10",
        },
      },
    );

    gsap.fromTo(
      name,
      0.6,
      { y: 144, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: name,
          start: "top bottom-=10",
        },
      },
    );

    gsap.fromTo(
      para,
      0.6,
      { y: 144, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: para,
          start: "top bottom-=10",
        },
      },
      0.4,
    );

    gsap.fromTo(
      first_scroll,
      1,
      { x: 0 },
      {
        x: 440,
        ease: Power1.easeIn,
        scrollTrigger: {
          trigger: scrollText,
          start: "top center+=10",
          scrub: true,
        },
      },
    );
    gsap.fromTo(
      second_scroll,
      1,
      { x: 44 },
      {
        x: -544,
        ease: Power1.easeIn,
        scrollTrigger: {
          trigger: scrollText,
          start: "top center+=10",
          scrub: true,
        },
      },
    );
  }, []);

  useEffect(() => {
    const menu = document.querySelectorAll(".nav-link");
    if (inView) {
      menu[1].classList.add("active");
      menu[0].classList.remove("active");
      menu[2].classList.remove("active");
      menu[3].classList.remove("active");
      menu[4].classList.remove("active");
    }
  }, [inView]);

  return (
    <section data-scroll-section>
      <motion.section
        id="About"
        initial={{ visibility: "hidden" }}
        animate={{ visibility: "visible", transition: { delay: 1 } }}
        exit={{ visibility: "hidden", transition: { delay: 1 } }}
        className="about"
        ref={reff}
      >
        <div className="width" ref={ref}>
          <h2 className="title">About me</h2>
          <div className="about-content">
            <div className="about_main" style={{ overflow: "hidden" }}>
              <h1>Akshit Rana</h1>
              <div className="about-right">
                <p>
                  A Programmer, Full stack web Developer and Illustrator born,
                  raised and currently living in Himachal Pradesh, India.&nbsp;I
                  have completed my <b>post-graduation</b> in the field of{" "}
                  <b>Computer Science</b> from{" "}
                  <b>
                    {" "}
                    <i> Himachal Pradesh University, Shimla</i>
                  </b>
                  .
                </p>
                <p className="about-sub">
                  I am a skilled software engineer with over <b>4 years</b> of
                  experience in web development. With a solid foundation in the
                  <b> MERN stack</b> (MongoDB, Express.js, React, and Node.js),
                  I specialize in creating scalable and efficient web solutions.
                </p>
                <p className="about-sub">
                  I have always been curious to understand how applications
                  work, and this curiosity brought me to the tech world. My
                  interests range from technology to design.&nbsp;
                </p>
                <p className="about-sub">
                  I enjoy designing new stuff and learning new
                  Technologies.&nbsp;If I'm not on my computer , am travelling
                  capturing moments and playing games.
                </p>
              </div>
              <br />
            </div>
          </div>
        </div>
      </motion.section>
      <section
        id="Art"
        style={{
          height: "44vh",
          backgroundColor: "transparent",
          color: "#111",
        }}
      >
        <div className="container">
          <div
            className="scroll_text"
            ref={(elem) => {
              scrollText = elem;
            }}
          >
            <motion.p transition={{ ease: "easeOut" }}>I Build Things</motion.p>
            <p>
              <span style={{ WebkitTextStroke: "0.2rem #111" }}>
                {" "}
                For the web
              </span>
            </p>
          </div>
        </div>
      </section>
      <Bio />
      <Skills setCursorHovered={setCursorHovered} />
    </section>
  );
};

export default About;
